import { createClient } from '@supabase/supabase-js'
import { env } from './env'

/**
 * Browser client. Uses the anon key only; every privileged rule is enforced
 * by Row Level Security and SECURITY DEFINER functions in the database.
 */
export const supabase = createClient(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY, {
  auth: {
    flowType: 'pkce',
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})

export const functionsUrl = `${env.VITE_SUPABASE_URL}/functions/v1`
